import { BernieGraphqlClient, FetchPolicy, RequestOptions } from 'bernie-graphql';
import * as generated from './types';
import * as operations from './operations';

export interface OperationResult<T> {
  data: T;
  errors?: [];
  extensions: any;
  headers: Headers;
}

function isFetchPolicy(requestOptions: RequestOptions | FetchPolicy): requestOptions is FetchPolicy {
  return typeof requestOptions === 'string';
}

export class ApiOperations {
  public constructor(private client: BernieGraphqlClient) {
    //
  }

  public flightsFlexibleSearch(
    variables: generated.FlightsFlexibleSearch.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.FlightsFlexibleSearch.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.flightsFlexibleSearchQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.FlightsFlexibleSearch.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public flightsShoppingPwaFlightInformationResults(
    variables: generated.FlightsShoppingPwaFlightInformationResults.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.FlightsShoppingPwaFlightInformationResults.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.flightsShoppingPwaFlightInformationResultsQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.FlightsShoppingPwaFlightInformationResults.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public flightsShoppingPwaFlightInformationResultsLoading(
    variables: generated.FlightsShoppingPwaFlightInformationResultsLoading.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.FlightsShoppingPwaFlightInformationResultsLoading.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.flightsShoppingPwaFlightInformationResultsLoadingQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.FlightsShoppingPwaFlightInformationResultsLoading.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public flightsShoppingPwaFlightSearchResultsFlightsSearch(
    variables: generated.FlightsShoppingPwaFlightSearchResultsFlightsSearch.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.FlightsShoppingPwaFlightSearchResultsFlightsSearch.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.flightsShoppingPwaFlightSearchResultsFlightsSearchQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.FlightsShoppingPwaFlightSearchResultsFlightsSearch.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public flightsShoppingPwaFlightSearchResultsLoadingFlightsSearch(
    variables: generated.FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearch.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearch.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.flightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearch.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public static withClient(client: BernieGraphqlClient) {
    return new ApiOperations(client);
  }
}
